// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__157JM","imageUploader":"EGiftCard_imageUploader__3-_ZJ"};